/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentBaseType
 */
export interface PaymentBaseType {
    /**
     * 
     * @type {string}
     * @memberof PaymentBaseType
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentBaseType
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentBaseType
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PaymentBaseType
     */
    documents: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PaymentBaseType
     */
    additional: Array<string>;
}

export function PaymentBaseTypeFromJSON(json: any): PaymentBaseType {
    return PaymentBaseTypeFromJSONTyped(json, false);
}

export function PaymentBaseTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentBaseType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
        'description': json['description'],
        'documents': json['documents'],
        'additional': json['additional'],
    };
}

export function PaymentBaseTypeToJSON(value?: PaymentBaseType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'type': value.type,
        'description': value.description,
        'documents': value.documents,
        'additional': value.additional,
    };
}


